import { createFileRoute } from "@tanstack/react-router"
import { DeleteGmailIntegration } from "modules/settings/components/integrations/gmail/DeleteGmailIntegration"

export const Route = createFileRoute("/_base/_auth/settings/channels/gmail/deleteIntegration/$id")({
  component: DeleteGmailIntegration,
})
